module.exports = __webpack_public_path__ + "img/1.cbe4c4b3.jpeg";